<div class="mb-8">

    <div class="w-full flex justify-between mt-8 mb-4">
        <app-btn-back [routeTo]="'/groups'" icon="fa fa-close" btnText="Cancel"></app-btn-back>
    </div>

    <div class="w-full mb-4">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">New Community</h1>
    </div>

    <form [formGroup]="pageForm" (ngSubmit)="create()">




        <div class="flex flex-col w-full">

            <span class="text-primary-500 text-sm font-semibold mb-2">Details</span>
            <div class="flex flex-col w-full border border-gray-200 rounded-lg p-4 mb-4">

                <div class="w-full mb-4">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Community Type *
                    </label>
                    <p class="text-xs text-primary-400 pb-1">The Community Type cannot be changed in the future</p>
                    <select type="groupType" formControlName="groupType" id="groupType" name="groupType"
                        class="border-0 px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white capitalize rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        @for (item of groupType; track $index) {
                        <option class="bg-white text-primary-500 px-3 py-2">
                            {{item}}</option>
                        }
                    </select>
                </div>

                @if (pageForm.get('groupType')?.value == groupTypeEnum.school) {
                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Academic Year *
                    </label>
                    <input type="number" type="academicYear" formControlName="academicYear" id="academicYear"
                        name="academicYear" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                    <div
                        class="{{ pageForm.get('academicYear')?.invalid && (pageForm.get('academicYear')?.dirty || pageForm.get('academicYear')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('academicYear')?.errors?.['required']) {
                        <p>
                            Value is required
                        </p>
                        }
                    </div>
                </div>
                }

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Name *
                    </label>
                    <input type="text" type="name" formControlName="name" id="name" name="name" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                    <div
                        class="{{ pageForm.get('name')?.invalid && (pageForm.get('name')?.dirty || pageForm.get('name')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('name')?.errors?.['required']) {
                        <p>
                            Value is required
                        </p>
                        }
                        @else if(pageForm.get('name')?.errors?.['minlength'] ||
                        pageForm.get('name')?.errors?.['maxlength'])
                        {
                        <p>
                            Min 10 and max 50 characters required
                        </p>
                        }
                    </div>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Description *
                    </label>
                    <textarea type="text" type="description" formControlName="description" id="description"
                        name="description" required maxlength="1000" minlength="10"
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        rows="4">
                </textarea>
                    <div
                        class="{{ pageForm.get('description')?.invalid && (pageForm.get('description')?.dirty || pageForm.get('description')?.touched) ? 'visible' : 'invisible'}} h-6 text-red-500 text-xs">
                        @if(pageForm.get('description')?.errors?.['required']){
                        <p>
                            Value is required
                        </p>
                        }
                        <!-- @else if(pageForm.get('description')?.errors?.['minlength'] ||
                        pageForm.get('description')?.errors?.['maxlength']){
                        <p>
                            Min 10 and max 1000 characters required
                        </p>
                        } -->
                    </div>
                </div>

            </div>

            <span class="text-primary-500 text-sm font-semibold mb-2">Contact</span>
            <div class="flex flex-col w-full border border-gray-200 rounded-lg p-4 mb-4">
                <div class="w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Primary Contact
                    </label>
                    <app-contact formControlName="primaryContact"></app-contact>
                </div>

                <div class="w-full mb-2">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Secondary Contact
                    </label>
                    <app-contact formControlName="secondaryContact"></app-contact>
                </div>

                <div class="w-full mb-1">
                    <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                        Email *
                    </label>
                    <input type="email" type="email" formControlName="email" id="email" name="email" required
                        class="border-0 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:outline-none focus:ring w-full py-2 px-3 ease-linear transition-all duration-150" />
                    <div
                        class="{{ pageForm.get('email')?.invalid && (pageForm.get('email')?.dirty || pageForm.get('email')?.touched) ? 'visible' : 'invisible'}}  pt-1 h-6 text-red-500 text-xs">
                        @if(pageForm.get('email')?.errors?.['required']){
                        <p>
                            Value is required
                        </p>
                        }
                    </div>
                </div>
            </div>

            <span class="text-primary-400 text-sm font-semibold mb-2">Address</span>
            <div class="flex flex-col w-full border border-gray-200 rounded-lg p-4 mb-4">

                <div class="w-full mb-2">
                    <div class="w-full rounded h-128 mb-4">
                        <app-add-location [location]="pageForm.get('position')?.value"
                            (locationChange)="setPosition($event)" label="Location"
                            description="Providing a location helps AtChurch users around you find your Community"></app-add-location>
                    </div>
                </div>

                <!-- Address -->
                <div class="flex flex-row gap-4 w-full">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            House Number
                        </label>
                        <input type="string" name="buildingNo" formControlName="buildingNo"
                            placeholder="House/Flat Number"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        <div class=" pt-1 h-6"></div>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Building Name
                        </label>
                        <input type="string" name="buildingName" formControlName="buildingName"
                            placeholder="Building Name"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        <div class=" pt-1 h-6"></div>
                    </div>
                </div>
                <div class="flex flex-row gap-4 w-full">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Address Line 1
                        </label>
                        <input type="string" name="addressLine1" formControlName="addressLine1"
                            placeholder="Address Line 1"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                        <div class=" pt-1 h-6"></div>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Address Line 2
                        </label>
                        <input type="string" name="addressLine2" formControlName="addressLine2"
                            placeholder="Address Line 2"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                    </div>
                </div>
                <div class="flex flex-row gap-4 w-full">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            City *
                        </label>
                        <input type="text" name="city" formControlName="city" placeholder="City" ng-required="true"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded normal-case text-sm shadow focus:ring w-full ease-linear transition-all duration-150"
                            required>
                        <div
                            class="{{pageForm.get('city')?.invalid && (pageForm.get('city')?.dirty || pageForm.get('city')?.touched) ? 'visible' : 'invisible' }} pt-1 h-6 text-red-500 text-xs">
                            @if(pageForm.get('city')?.errors?.['required']){
                            <p>
                                Value is required
                            </p>
                            }
                        </div>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Country *
                        </label>
                        <app-country formControlName="country"></app-country>
                    </div>
                </div>
            </div>

            <span class="text-primary-400 text-sm font-semibold mb-2">Configurations</span>
            <div class="flex flex-col w-full border border-gray-200 rounded-lg p-4 mb-4">

                <!-- Fiscal Year Settings -->
                <div class="flex flex-row gap-4 w-full mb-6 mt-4">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Fiscal Year Start
                        </label>
                        <input type="date" name="fiscalYearStart" formControlName="fiscalYearStart"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Fiscal Year End
                        </label>
                        <input type="date" name="fiscalYearEnd" formControlName="fiscalYearEnd"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                    </div>
                </div>

                <!-- AI Settings -->
                <div class="w-full mb-6">
                    <label class="flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="isAiEnabled"
                            class="rounded border-blueGray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 mr-2">
                        <span class="text-blueGray-600 text-xs font-bold uppercase">Enable AI Receipt Reader</span>
                    </label>
                    <p class="text-xs text-blueGray-400 mt-1 normal-case font-normal leading-relaxed">
                        When enabled, group Treasurer(s) can upload receipts and automatically extract expense details.
                    </p>
                </div>

                <!-- Chat Settings -->
                <div class="w-full mb-6">
                    <label class="flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="isChatAllowed"
                            class="rounded border-blueGray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 mr-2">
                        <span class="text-blueGray-600 text-xs font-bold uppercase">Allow Group Chat</span>
                    </label>
                    <p class="text-xs text-blueGray-400 mt-1 normal-case font-normal leading-relaxed">
                        When enabled, members can access the group chat interface to message each other.
                    </p>
                </div>

                <!-- Default Currency & Bible Type -->
                <div class="flex flex-row gap-4 w-full mb-6">
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Default Currency *
                        </label>
                        <select formControlName="currency"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                            <option value="usd">USD</option>
                            <option value="eur">EUR</option>
                            <option value="gbp">GBP</option>
                            <option value="aed">AED</option>
                            <option value="inr">INR</option>
                        </select>
                    </div>
                    <div class="w-1/2">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                            Bible Type *
                        </label>
                        <select formControlName="bibleType"
                            class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:ring w-full ease-linear transition-all duration-150">
                            <option value="protestant">Protestant</option>
                            <option value="catholic">Catholic</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="w-full mb-1">
                <app-btn-submit [isDisabled]="!pageForm.valid || working" [isLoading]="working" [actionText]="'Create'"
                    [icon]="'fa fa-save'"></app-btn-submit>
            </div>

        </div>
    </form>

</div>